import {dictionaryRoute} from './module/dictionary'
import {usersRoute} from './module/usersRoute'
import {educationPlanRoute} from './module/educationPlan'
import {testRoute} from './module/test'
import {videoLessonRoute} from './module/videoLesson'
import {meetRoute} from './module/meet'
import {VisitorLog} from './module/visitorLog'
import {Themes} from './module/themes'
import {Question} from './module/question'
import {Retake} from './module/retake'
import {SuperUser} from './module/superUser'
import {ROLE_ADMIN, ROLE_EXAMINER, ROLE_SUPPORT, ROLE_TEACHER} from '../../helpers'
import {SupportUser} from './module/supportUser'

export const AdminRoute = [
  ...dictionaryRoute,
  ...usersRoute,
  ...educationPlanRoute,
  ...testRoute,
  ...videoLessonRoute,
  ...meetRoute,
  ...VisitorLog,
  ...Themes,
  ...Question,
  ...Retake,
  ...SuperUser,
  ...SupportUser,
  {
    path: 'statistics',
    name: 'statistics',
    component: () => import('../../components/Admin/Statistics.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER]
    }
  },
  {
    path: 'forget-password',
    name: 'ForgetPasswordUsers',
    component: () => import('../../components/Admin/ForgetPasswordUsers.vue'),
    meta: {
      access: ['admin']
    }
  },
  {
    path: 'exam',
    component: () => import('../../components/Admin/Exam.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'create-exam',
    component: () => import('../../components/Admin/CreateExam.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'edit-exam/:id',
    component: () => import('../../components/Admin/EditExam.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'examiners',
    component: () => import('../../components/Admin/Examiners.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'create-examiner',
    component: () => import('../../components/Admin/CreateExaminer.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'edit-examiner/:id',
    component: () => import('../../components/Admin/EditExaminer.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'report-card',
    component: () => import('../../components/Admin/reportСard.vue'),
    meta: {
      access: [ROLE_EXAMINER]
    }
  },
  {
    path: 'report-card-administrator',
    component: () => import('../../components/Admin/reportСardAdministrator.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'exam-for-examiner/:id',
    component: () => import('../../components/Admin/ExamForExaminer.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'region',
    component: () => import('../../components/Admin/region.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'exam-results/:id',
    component: () => import('../../components/Admin/ExamResults.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'exam-results-admin/:id',
    component: () => import('../../components/Admin/examResultsAdmin.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'webinars',
    component: () => import('../../components/Admin/WebinarsAdmin.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER, ROLE_EXAMINER]
    }
  },
  {
    path: 'create-webinar',
    component: () => import('../../components/Admin/CreateWebinar.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER, ROLE_EXAMINER]
    }
  },
  {
    path: 'edit-webinar/:id',
    component: () => import('../../components/Admin/EditWebinar.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER, ROLE_EXAMINER]
    }
  },
  {
    path: 'webinars-view/:id',
    component: () => import('../../components/Admin/WebinarsViewAdmin.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER, ROLE_EXAMINER]
    }
  },
  {
    path: 'conducting-webinar',
    component: () => import('../../components/Admin/ConductingWebinar.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'create-recording-webinar',
    component: () => import('../../components/Admin/CreateRecordingWebinar.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'edit-recording-webinar/:id',
    component: () => import('../../components/Admin/EditRecordingWebinar.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'webinar',
    component: () => import('../../components/Admin/WebinarAdmin.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER]
    }
  },
  {
    path: 'start-webinar/:id',
    name: 'AdminWebinarPage',
    component: () => import('../../components/Admin/webinarForConductingWebinar.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER]
    }
  },
  {
    path: 'webinar-exams/:id',
    component: () => import('../../components/Admin/WebinarExams.vue'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER]
    }
  },
  // {
  //   path: 'questions-webinars',
  //   component: () => import('../../components/Admin/QuestionsWebinars.vue')
  // },
  {
    path: 'questions-webinars',
    name: 'WebinarsChat',
    component: () => import('../../components/Admin/WebinarQuestion'),
    meta: {
      access: [ROLE_ADMIN, ROLE_TEACHER]
    },
    children: [
      {
        path: ':id',
        name: 'WebinarsChatShow',
        component: () => import('../../components/Admin/WebinarQuestion/chat'),
        meta: {
          access: [ROLE_ADMIN, ROLE_TEACHER]
        }
      }
    ]
  },
  {
    path: 'support',
    component: () => import('../../components/router-view'),
    children: [
      {
        path: '/',
        name: 'Support',
        component: () => import('../../components/Admin/Support'),
        meta: {
          access: [ROLE_SUPPORT]
        }
      },
      {
        path: ':id',
        name: 'SupportChat',
        component: () => import('../../components/Admin/Support/chat'),
        meta: {
          access: [ROLE_SUPPORT]
        }
      }
    ]
  },
  {
    path: 'admin-questions',
    component: () => import('../../components/Admin/AdminQuestions.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'certificates',
    component: () => import('../../components/Admin/Certificates.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'create-certificate',
    component: () => import('../../components/Admin/CreateCertificate.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'edit-certificate/:id',
    component: () => import('../../components/Admin/EditCertificate.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'role',
    component: () => import('../../components/Admin/Role.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'create-role',
    component: () => import('../../components/Admin/Createrole.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'scorms',
    component: () => import('../../components/Admin/Scorms.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'create-scorm',
    component: () => import('../../components/Admin/CreateScorm.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'edit-scorm/:id',
    component: () => import('../../components/Admin/EditScorm.vue'),
    meta: {
      access: [ROLE_ADMIN]
    }
  },
  {
    path: 'audience-exam',
    component: () => import('../../components/Admin/audienceExam.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'create-audience-exam',
    component: () => import('../../components/Admin/createAudienceExam.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'edit-audience-exam/:id',
    component: () => import('../../components/Admin/editAudienceExam.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'audience',
    component: () => import('../../components/Admin/audience.vue'),
    meta: {
      access: []
    }
  },
  {
    path: 'audience-region/:id',
    component: () => import('../../components/Admin/audienceRegion.vue'),
    meta: {
      access: []
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/index.js